<template>
  <el-dialog
    :title="$t('text.select_run_to_analyse')"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    width="850px"
    @close="closeDialog()"
    class="select-run-to-analyse-dialog"
  >
    <div v-loading="loading">
      <el-select
        v-model="product"
        :placeholder="$t('text.please_select_a_product')"
        size="small"
        class="wp-100 max-w-300 mb-20 filter-selelct"
        filterable
      >
        <el-option
          v-for="item in products"
          :key="item.id"
          :label="item.productName"
          :value="item.id"
        >
        </el-option>
      </el-select>
      <el-table
        border
        :data="list"
        size="mini"
        @current-change="handleCurrentChange"
        :row-class-name="rowClassName"
        max-height="500px"
      >
        <el-table-column width="50px">
          <template slot-scope="scope">
            <el-radio :label="scope.row.id" v-model="selectRowId"
              >&nbsp;</el-radio
            >
          </template>
        </el-table-column>
        <el-table-column label="ID" prop="id" width="50px"> </el-table-column>
        <el-table-column :label="$t('text.date')" prop="date" width="160px">
          <template slot-scope="scope">
            {{
              moment
                .utc(scope.row.startTime)
                .tz($store.state.pods.selectedUtcOffset)
                .format('DD/MM/YY @ h:mm a')
            }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('text.tester')" prop="doneBy" width="150px">
        </el-table-column>
        <el-table-column :label="$t('text.pod')" prop="podMac">
        </el-table-column>
        <el-table-column :label="$t('text.position')" prop="position">
        </el-table-column>
        <el-table-column
          :label="$t('text.weight') + '(Kg)'"
          prop="weight"
          width="100px"
        >
        </el-table-column>
      </el-table>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" type="primary" @click="select()">{{
        $t('text.select')
      }}</el-button>
      <el-button size="small" @click="closeDialog()">{{
        $t('text.close') | firstLetterCapitalize
      }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import CommonApiService from '@/services/CommonApiService.js'
import moment from 'moment-timezone'
export default {
  data() {
    return {
      moment,
      dialogVisible: false,
      loading: false,
      currentRow: '',
      list: [],
      products: [],
      product: ''
    }
  },
  computed: {
    selectRowId() {
      return this.currentRow ? this.currentRow.id : ''
    }
  },
  mounted() {
    // Fixed a problem with the filterable select box, which cannot pop up on the soft keyboard on IOS
    Array.from(document.getElementsByClassName('filter-selelct')).forEach(
      item => {
        item.children[0].children[0].removeAttribute('readOnly')
        item.children[0].children[0].onblur = function() {
          let _this = this
          setTimeout(() => {
            _this.removeAttribute('readOnly')
          }, 200)
        }
      }
    )
  },
  watch: {
    product() {
      this.$store.commit('pods/SET_SELECTED_PRODUCT_ID', this.product)
      this.getData()
    }
  },
  methods: {
    openDialog() {
      this.dialogVisible = true
      this.getProducts()
    },
    closeDialog() {
      this.currentRow = ''
      this.dialogVisible = false
    },
    select() {
      let row = this.currentRow || this.list[0]
      this.$parent.tableData = [row]
      this.$parent.id = row.id
      this.closeDialog()
    },
    handleCurrentChange(val) {
      this.currentRow = val
    },
    rowClassName(e) {
      let rowName = ''
      if (this.selectRowId === e.row.id) {
        rowName = 'selection-row'
      }
      return rowName
    },
    getProducts() {
      this.loading = true
      CommonApiService.GetProducts()
        .then(response => {
          this.loading = false
          this.products = response.data.data
          this.product =
            this.$store.state.pods.selectedProductId || this.products[0].id
          this.getData()
        })
        .catch(() => {
          this.loading = false
        })
    },
    getData() {
      this.loading = true
      CommonApiService.GetCharacterizationByProduct(this.product)
        .then(response => {
          this.loading = false
          this.list = response.data.data
        })
        .catch(() => {
          this.loading = false
        })
    }
  }
}
</script>
